import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './paintingElevation.module.scss';
//import { color } from "html2canvas/dist/types/css/types/color";
class PaintingElevation extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { paintDetails, wallpaperDetails } = pageDetails;
        const { elevationImage } = pageDetails;
        let isPainting, isWallpaper= false;
        let wallpaperTables={wallpaper:[]}, paintTables={paint:[]}, imageTables={paint:{}};
        if(paintDetails && paintDetails.length > 0){
            (paintDetails || []).map(paint => {
                let { woodworkCovering, paintingThumbnails, productName, sectionName, subCategory, area, processType } = paint;
                if(paintingThumbnails && paintingThumbnails.length){
                    imageTables['paint'][sectionName]={paintCode: paintingThumbnails[0]["colourCode"], paintUrl: paintingThumbnails[0]["imageUrl"]}
                }
                paintTables['paint'].push({'ProductName': productName, 'Subcategory': subCategory, 'sectionName': sectionName, woodworkCovering, area, processType});
                return paint;
            })
            isPainting = true
        }else{

        }
        if(wallpaperDetails && wallpaperDetails.length >0){
            (wallpaperDetails || []).map((wall, index) => {
                let { brand, collectionName, numberOfRolls, area, imageUrl, productName, sectionName, scope } = wall;
                imageTables['paint'][sectionName] = {wallpaper: imageUrl}
                wallpaperTables['wallpaper'].push({brand, numberOfRolls, area, collectionName, sectionName,  productName, scope});
                return wall;
            })
            isWallpaper = true;
        }
        let pageName = pageDetails?.name;
        pageName = pageName ? pageName.split('-')[0]?.trim() : pageName;
        pageName = (isPainting && isWallpaper) ? pageName+" - Painting & Wallpaper": isPainting ? pageName+" - Painting": pageName+" - Wallpaper"
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageName}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className={styles["tables-alignment"]} style={{margin: "15px"}}>
                    <div className={styles["paintingArea"]}>
                    {
                        Object.keys(paintTables).length && Object.keys(paintTables).map(key=>{
                            if(key === 'paint'){
                                let details = paintTables[key];
                                return (details || []).map(paintobj=>{
                                    let  { ProductName,  Subcategory, sectionName, processType, area } = paintobj;
                                    return (
                                        <div className={styles['columnDivs']}>
                                            <div className={styles.Table}>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']} style={{borderRight: "none"}}>
                                                        <p>{`PAINT DETAILS ${sectionName && sectionName.toLowerCase() !== 'default' ? " - "+sectionName.toUpperCase() : ""}`}</p>
                                                    </div>
                                                    <div className={styles.Cell+" "+styles['headings']} style={{borderLeft: "none"}}>
                                                        <p></p>
                                                    </div>
                                                </div>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>PRODUCT NAME</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{ProductName ? ProductName.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>SUBCATEGORY</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{Subcategory ? Subcategory.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>PROCESS TYPE</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{processType ? processType.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>AREA</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{area ? area.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            return null;
                        })   
                    }

                    <div className={styles['columnDivs']}>
                    {
                        Object.keys(paintTables).length && Object.keys(paintTables).map(key=>{
                            if(key === 'paint'){
                                let details = paintTables[key];
                                return (details || []).map(paintobj=>{
                                    let  { sectionName, woodworkCovering } = paintobj;
                                    return (
                                        (woodworkCovering && !woodworkCovering?.toLowerCase()?.includes('homelane'))
                                        ?<div className={styles.Table}>
                                            <div className={styles.Row}>
                                                <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                                    <p>{`SCOPE ${sectionName && sectionName.toLowerCase() !== 'default' ? " ("+sectionName.toUpperCase()+")": ""}`}</p>
                                                </div>
                                                <div className={styles.Cell+" "+styles['headings']} style={{borderLeft: "none"}}>
                                                    <p></p>
                                                </div>
                                            </div>
                                            <div className={styles.Row}>
                                                <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                    <p>OIL PRIMER</p>
                                                </div>
                                                <div className={styles.Cell+' '+styles['cell-right']} >
                                                    <p>HOMELANE</p>
                                                </div>
                                            </div>
                                        </div>
                                        :null
                                    )
                                })
                            }
                            return null;
                        })
                    }
                    </div>
                    </div>

                    <div className={styles["wallpaperArea"]}>
                    {
                        Object.keys(wallpaperTables).length && Object.keys(wallpaperTables).map(key=>{
                            if(key ==='wallpaper'){
                                let details = wallpaperTables[key];
                                return (details || []).map(wllObj=>{
                                    let  { brand,  numberOfRolls, area, sectionName, productName, collectionName } = wllObj;
                                    return (
                                        <div className={styles['columnDivs']} >
                                            <div className={styles.Table}>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']} style={{borderRight: "none"}}>
                                                        <p>{`WALLPAPER DETAILS ${sectionName && sectionName.toLowerCase() !== "default" ? " - "+sectionName.toUpperCase() : ""}`}</p>
                                                    </div>
                                                    <div className={styles.Cell+" "+styles['headings']} style={{borderLeft: "none"}}>
                                                        <p></p>
                                                    </div>
                                                </div>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>BRAND NAME</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{brand ? brand.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                                {numberOfRolls?<div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>NO OF ROLLS</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{numberOfRolls ? numberOfRolls.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>:""}
                                                {area?<div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>AREA</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{area ? area.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>:""}
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>COLLECTION NAME</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{collectionName ? collectionName.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className={styles.Row}>
                                                    <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                        <p>PRODUCT NAME</p>
                                                    </div>
                                                    <div className={styles.Cell+' '+styles['cell-right']}>
                                                        <p>{productName ? productName.toString().toUpperCase(): "NA"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            return null;
                        })  
                    }

                    <div className={styles['columnDivs']}>
                    {
                        Object.keys(wallpaperTables).length && Object.keys(wallpaperTables).map(key=>{
                            if(key === 'wallpaper'){
                                let details = wallpaperTables[key];
                                    return (details || []).map(wllObj=>{
                                        let  { sectionName, scope } = wllObj;
                                        return (
                                        (scope?.["woodwork"] && !scope?.["woodwork"]?.toLowerCase()?.includes('homelane'))
                                        ?<div className={styles.Table}>
                                            <div className={styles.Row}>
                                                <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                                    <p>{`SCOPE ${sectionName && sectionName.toLowerCase() !== 'default' ? " ("+sectionName.toUpperCase()+")": ""}`}</p>
                                                </div>
                                                <div className={styles.Cell+" "+styles['headings']} style={{borderLeft: "none"}}>
                                                    <p></p>
                                                </div>
                                            </div>
                                            <div className={styles.Row}>
                                                <div className={styles['Cell']+" "+styles['headings']+' '+styles['cell-left']}>
                                                    <p>OIL PRIMER</p>
                                                </div>
                                                <div className={styles.Cell+' '+styles['cell-right']} >
                                                    <p>HOMELANE</p>
                                                </div>
                                            </div>
                                        </div>
                                        :null
                                        )
                                    })
                                }
                                return null;
                            }
                        )
                    }
                    </div>
                    </div>
                    <div className={styles['imageTables']}>
                        {
                            Object.keys(imageTables).length && Object.keys(imageTables).map(imgKey=>{
                                let paint = imageTables[imgKey];
                                let section1 = paint['section-1'] || paint['DEFAULT'] || {};
                                let section2 = paint['section-2'] || {};

                                let section1Heading = "NO IMAGE";
                                if(section1['wallpaper'] && !section1['paintUrl'] && !section1['paintCode']) {
                                    section1Heading = "WALLPAPER IMAGE";
                                } else if(section1['paintUrl'] || section1['paintCode']) {
                                    section1Heading = "PAINT IMAGE"   
                                }

                                let section2Heading = "NO IMAGE";
                                if(section2['wallpaper'] && !section2['paintUrl'] && !section2['paintCode']) {
                                    section2Heading = "WALLPAPER IMAGE";
                                } else if(section2['paintUrl'] || section2['paintCode']) {
                                    section2Heading = "PAINT IMAGE"   
                                }


                                if(paint){
                                    return (<div className={styles.Table+' '+styles['imageTables']}>
                                        <div className={styles.Row}>
                                            {
                                            (section1['wallpaper'] || section1['paintUrl'] || section1['paintCode']) &&
                                            <div className={styles['Cell']+" "+styles['headings']+" "+styles['cell-left-image']}>
                                                <p style={{textAlign: 'center'}}>{section1Heading}</p>
                                                {
                                                    (section1['wallpaper'] && !section1['paintUrl'] && !section1['paintCode'])?  <img crossOrigin="anonymous" alt="" src={ section1['wallpaper']+"?ver="+new Date().getTime() || defaultImage }  /> : (!section1['paintCode'] && section1['paintUrl']) ? <img crossOrigin="anonymous" alt="" src={ section1['paintUrl']+"?ver="+new Date().getTime() || defaultImage}   /> : (!section1['wallpaper'] && !section1['paintUrl'] && section1['paintCode']) ?<div className={styles["filledDiv"]} style={{background: section1['paintCode']}}>{"test"}</div>  :<img alt="" src={ defaultImage}  /> 
                                                }
                                            </div>
                                            }
                                            {  
                                            (section2['wallpaper'] || section2['paintUrl'] || section2['paintCode']) &&                                          
                                                <div className={styles['Cell']+" "+styles['headings']+" "+styles['cell-right-image']}>
                                                    <p style={{textAlign: 'center'}}>{section2Heading}</p>
                                                    {
                                                        (section2['wallpaper'] && !section2['paintUrl'] && !section2['paintCode'])?  <img crossOrigin="anonymous" alt="" src={ section2['wallpaper']+"?ver="+new Date().getTime() || defaultImage }  /> : (!section2['paintCode'] && section2['paintUrl']) ? <img crossOrigin="anonymous" alt="" src={ section2['paintUrl']+"?ver="+new Date().getTime() || defaultImage}   /> : (!section2['wallpaper'] && !section2['paintUrl'] && section2['paintCode']) ?<div className={styles["filledDiv"]} style={{background: section2['paintCode']}}>{"test"}</div>  :<img alt="" src={ defaultImage}  />
                                                    }
                                                </div>
                                            }

                                        </div>  
                                    </div>)
                                }
                                return null;
                            })
                        }
                    </div>
                            
                    </div>    
                        {/* > */}
            </React.Fragment>

        )
    }

}
export default PaintingElevation;